import { currencies } from "@megaron/catalog-contracts";
import { baseDocSerializer, docTypeHash } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const fulfillmentOrderDocName = (orderNumber: number) => `WEB-${orderNumber}`;

export const fulfillmentOrderDocSerializer = Serializers.object({
  ...baseDocSerializer("fulfillment-order").fields,
  orderId: Serializers.string,
  orderNumber: Serializers.integer,
  fulfillmentStatus: Serializers.string,
  financialStatus: Serializers.string,
  deliveryMethod: Serializers.string,
  processedAt: Serializers.datetime,
  cancelledAt: Serializers.datetime.nullable(),
  currency: Serializers.stringOneOf(...currencies),
});

export type FulfillmentOrderDoc = SerializerValue<typeof fulfillmentOrderDocSerializer>;

export const fulfillmentOrderDocTypeHash = docTypeHash(fulfillmentOrderDocSerializer);
